"use client";

import { MokaAdvantageBar } from "@/components/moka-advantage-bar";
import { useMokaMatchContext } from "@/components/moka-match/moka-match-root";

const MokaMatchAdvantageBar = () => {
  const { isAnalysisModeActive, position, predictedBlackWinProbability, winner } =
    useMokaMatchContext();

  return (
    <MokaAdvantageBar
      blackWinProbability={position.blackWinProbability}
      predictedBlackWinProbability={isAnalysisModeActive ? predictedBlackWinProbability : null}
      winner={winner}
    />
  );
};

MokaMatchAdvantageBar.displayName = "MokaMatchAdvantageBar";

export { MokaMatchAdvantageBar };
